class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  isUpdating = false;
  static initialLoadDone = false;

  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

     this.querySelector('#CartDrawer-Form')?.addEventListener('change', debouncedOnChange.bind(this));
     if (!window.upsellHandlerAttached) {
       document.addEventListener('upsell-product-added', () => {
         const activeCart = document.querySelector('cart-items, cart-drawer-items');
         if (activeCart) activeCart.onCartUpdate();
       });
       window.upsellHandlerAttached = true;
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items' && event.cartData?.item_count > 0) {
        return;
      }
      this.onCartUpdate();
    });

    if (!CartItems.initialLoadDone) {
      
      fetch(routes.cart_url + '.js')
        .then((res) => res.json())
        .then((cartData) => {
          const cartDrawer = document.getElementById('CartDrawer');
          if (cartData.item_count === 0 && cartDrawer) {
            const progressSection = cartDrawer.querySelector('.free-shipping');
            const progressMessages = cartDrawer.querySelector('.cart-progress-messages');
            if (progressSection) progressSection.classList.add('hidden');
            if (progressMessages) progressMessages.classList.add('hidden');
          }
          this.checkFreeGift(cartData); 
          this.markFreeGiftItem();
          CartItems.initialLoadDone = true;
        })
        .catch((e) => console.error('LOG ERROR: Initial fetch false', e));
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.isUpdating) return;
    this.isUpdating = true;

    const isDrawer = this.tagName === 'CART-DRAWER-ITEMS' || document.querySelector('cart-drawer.active');
    const sectionId = isDrawer ? 'cart-drawer' : 'main-cart-items';

    fetch(`${routes.cart_url}?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = isDrawer 
          ? ['cart-drawer-items', '.cart-drawer__footer', '.free-shipping', '.cart-progress-messages']
          : ['cart-items', '#main-cart-footer'];

        selectors.forEach(selector => {
          const target = document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) {
            target.replaceWith(source);
          }
        });

        this.markFreeGiftItem();
        return fetch(routes.cart_url + '.js').then(res => res.json());
      })
      .then((cartData) => {
        const cartDrawer = document.getElementById('CartDrawer');
        if (cartData.item_count === 0 && cartDrawer) {
          const progressSection = cartDrawer.querySelector('.free-shipping');
          const progressMessages = cartDrawer.querySelector('.cart-progress-messages');
          if (progressSection) progressSection.classList.add('hidden');
          if (progressMessages) progressMessages.classList.add('hidden');
        }
        this.checkFreeGift(cartData);
      })
      .catch((e) => console.error(e))
      .finally(() => {
        setTimeout(() => { this.isUpdating = false; }, 100);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        let message = '';

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const target = element.querySelector(section.selector) || element;
            target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }
        });

        this.checkFreeGift(parsedState);

        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        if (quantityElement) {
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);
        
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch((error) => {
        console.error("Cart update error:", error);
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  checkFreeGift(cartData) {
    const cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    const freeGiftVariantId = cartDrawer.dataset.freeGiftVariant;
    const freeGiftAmount = parseInt(cartDrawer.dataset.freeGiftAmount || '0', 10);
    const freeShippingAmount = parseInt(cartDrawer.dataset.freeShippingAmount || '0', 10);
    const DISCOUNT_CODE = 'FREETOTEBAG';

    const freeGiftItem = cartData.items.find(
      (item) =>
      item.variant_id == freeGiftVariantId &&
      item.properties &&
      item.properties._free_gift === 'true'
    );

    let adjustedTotal = cartData.total_price;
    if (freeGiftItem) {
      adjustedTotal = cartData.total_price - freeGiftItem.final_line_price;
    }

    const shouldAddGift = adjustedTotal >= freeGiftAmount && !freeGiftItem && freeGiftVariantId;
    const shouldRemoveGift = adjustedTotal < freeGiftAmount && freeGiftItem && freeGiftItem.key;

    if (shouldAddGift) {
      fetch(routes.cart_add_url, { ...fetchConfig(),
        body: JSON.stringify({
          items: [{
            id: freeGiftVariantId,
            quantity: 1,
            properties: { _free_gift: 'true' }
          }],
        }),
      })
      .then(() => {
        return fetch(`/checkout?discount=${DISCOUNT_CODE}`, { mode: 'no-cors' });
      })
      .then(() => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
      });
    }
    else if (shouldRemoveGift) {
      const body = JSON.stringify({
        id: freeGiftItem.key,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(routes.cart_change_url, { ...fetchConfig(), body })
        .then((response) => response.json())
        .then((parsedState) => {
          fetch('/checkout?discount=', { mode: 'no-cors' })
            .then(() => {
              this.getSectionsToRender().forEach((section) => {
                const element = document.getElementById(section.id);
                if (!element) return;
                const target = element.querySelector(section.selector) || element;
                if (parsedState.sections?.[section.section]) {
                  target.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }
              });
              this.updateProgressMessages(parsedState.total_price, freeGiftAmount, freeShippingAmount);
            });
        })
        .catch((e) => console.error('Error removing gift/discount:', e));
    }
    else {
      this.updateProgressMessages(cartData.total_price, freeGiftAmount, freeShippingAmount);
    }
  }

  updateProgressMessages(totalPrice, giftThreshold, shippingThreshold) {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    const container = drawer.querySelector('.cart-progress-messages');
    if (!container) return;

    const freeShippingEl = drawer.querySelector('free-shipping');
    const currencySymbol = freeShippingEl ? freeShippingEl.dataset.marketCurrency : '';

    const giftMsg = container.querySelector('.msg-gift');
    const shippingMsg = container.querySelector('.msg-shipping');
    const successMsg = container.querySelector('.msg-success');

    [giftMsg, shippingMsg, successMsg].forEach(el => el && el.classList.add('hidden'));

    if (typeof totalPrice !== 'number' || isNaN(totalPrice)) return;

    const diffShipping = shippingThreshold - totalPrice;
    const diffGift = giftThreshold - totalPrice;

    const shippingReached = shippingThreshold === 0 || diffShipping <= 0;
    const giftReached = giftThreshold === 0 || diffGift <= 0;
    const isShippingFirst = shippingThreshold < giftThreshold;

    if (shippingReached && giftReached) {
      if (successMsg) successMsg.classList.remove('hidden');
    } 
    else if (isShippingFirst) {
      if (!shippingReached) {
        showRemaining(shippingMsg, diffShipping);
      } else if (!giftReached) {
        showRemaining(giftMsg, diffGift);
      }
    } 
    else {
      if (!giftReached) {
        showRemaining(giftMsg, diffGift);
      } else if (!shippingReached) {
        showRemaining(shippingMsg, diffShipping);
      }
    }

    function showRemaining(msgElement, diff) {
      if (msgElement && !isNaN(diff)) {
        const amountSpan = msgElement.querySelector('.remaining');
        if (amountSpan) {
          amountSpan.textContent = diff / 100 + ' ' + currencySymbol;
          msgElement.classList.remove('hidden');
        }
      }
    }
    
  }

  markFreeGiftItem() {
    const giftInput = document.querySelector(
      'input[data-cart-quantity][data-properties]'
    );

    const giftItems = document.querySelectorAll('.cart-item');

    giftItems.forEach((item) => {
      const propertiesEl = item.querySelector('[data-line-item-properties]');
      if (!propertiesEl) return;

      try {
        const properties = JSON.parse(propertiesEl.textContent);
        if (properties._free_gift === 'true') {
          item.classList.add('is-free-gift');
        }
      } catch (e) {}
    });
  }

}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}